import { render, staticRenderFns } from "./CustomInputUsedForGender.vue?vue&type=template&id=1c5fa2aa&scoped=true&"
import script from "./CustomInputUsedForGender.vue?vue&type=script&lang=js&"
export * from "./CustomInputUsedForGender.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputUsedForGender.vue?vue&type=style&index=0&id=1c5fa2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5fa2aa",
  null
  
)

component.options.__file = "CustomInputUsedForGender.vue"
export default component.exports